import { createAction } from "@reduxjs/toolkit";
// types
import { USER_LANGUAGE } from "./types";

export const setLanguage = createAction<string>(USER_LANGUAGE);
